import { render, staticRenderFns } from "./relationship.vue?vue&type=template&id=3875ac66&scoped=true&"
import script from "./relationship.vue?vue&type=script&lang=js&"
export * from "./relationship.vue?vue&type=script&lang=js&"
import style0 from "./relationship.vue?vue&type=style&index=0&id=3875ac66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3875ac66",
  null
  
)

export default component.exports